<script>
import { ContactForm } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'
import { get } from 'lodash'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'View Contact Form',
      verboseName: 'Formularz kontaktowy',
      verboseNamePlural: 'Formularze kontaktowe',
      listFields: [
        { prop: 'name', label: 'Nazwa' },
        { prop: 'email', label: 'Email' },
        {
          prop: 'created',
          label: 'Data zapytania',
          formatter: this.formatDate('created')
        },
        { prop: 'ip_address', label: 'Adres IP' },
        {
          prop: 'notification_email_sent_at',
          label: 'Przesłano e-mailem',
          type: 'boolean'
        },
        {
          prop: 'notification_email_sent_to',
          label: 'Przesłano do',
          formatter: this.sentTo('notification_email_sent_to')
        }
      ]
    }
  },
  computed: {
    service() {
      return ContactForm
    }
  },
  methods: {
    actions(scope) {
      return [
        {
          component: 'router-link',
          attrs: {
            to: this.getEditRoute(scope.row)
          },
          children: [this.getButtonComponent({ icon: 'fa fa-edit' })]
        }
      ]
    },
    sentTo(field) {
      return value => {
        const fieldValue = get(value, field)
        if (fieldValue) {
          return fieldValue.join(', ')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .box {
    width: 100%;
  }
}
</style>
